import "./Footer.css"

const Footer = () => {
  return (
    <footer>
        <p>© <a href='/'>Dian Novais</a> - Todos os direitos reservados</p>
    </footer>
  )
}

export default Footer